import React from 'react';
import { Wrapper } from '../Wrapper';
import {
    Video as RawVideo,
    VideoSource,
} from '../../../components/landingPage/Video';
import { Dataset, SanityObject } from '../../../lib/landingPage';
import { ImageProps } from '../Image';
import { getPoster } from '../../../lib/landingPage/video';

export type VideoProps = {
    sources: VideoSource[];
    className?: string;
    muted?: boolean;
    autoPlay?: boolean;
    loop?: boolean;
    poster?: SanityObject<ImageProps>;
    dataset?: Dataset;
};

export const Video = Wrapper((props: VideoProps): JSX.Element | null => {
    return (
        <RawVideo
            {...props}
            poster={getPoster(props.poster, props.dataset)?.url()}
        />
    );
}, 'video');
